var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3119 4.57367H15.344C14.886 2.3464 12.9267 0.747013 10.6528 0.744141H8.73802C6.46412 0.747013 4.50486 2.3464 4.04684 4.57367H1.07895C0.550207 4.57367 0.121582 5.0023 0.121582 5.53104C0.121582 6.05979 0.550207 6.48846 1.07895 6.48846H2.03633V18.9345C2.03951 21.5769 4.18084 23.7183 6.82327 23.7214H12.5676C15.21 23.7183 17.3514 21.5769 17.3545 18.9345V6.48846H18.3119C18.8407 6.48846 19.2693 6.05984 19.2693 5.53109C19.2693 5.00234 18.8407 4.57367 18.3119 4.57367ZM8.73806 17.0197C8.73806 17.5485 8.30944 17.9771 7.78069 17.9771C7.2519 17.9771 6.82327 17.5485 6.82327 17.0197V11.2754C6.82327 10.7467 7.2519 10.318 7.78065 10.318C8.30939 10.318 8.73802 10.7467 8.73802 11.2754V17.0197H8.73806ZM12.5676 17.0197C12.5676 17.5485 12.139 17.9771 11.6102 17.9771C11.0815 17.9771 10.6529 17.5485 10.6529 17.0197V11.2754C10.6529 10.7467 11.0815 10.318 11.6102 10.318C12.139 10.318 12.5676 10.7467 12.5676 11.2754V17.0197ZM6.02962 4.57367C6.43683 3.42701 7.52125 2.66037 8.73806 2.65888H10.6529C11.8697 2.66037 12.9541 3.42701 13.3613 4.57367H6.02962Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFill);
export default __webpack_public_path__ + "static/media/deleteFill.43318750bf2e6cd51cad8d8449db2381.svg";
export { ForwardRef as ReactComponent };